module.exports = __webpack_public_path__ + "img/det1.6a999529.png";